export default __webpack_public_path__ + "static/media/savedBookmark.6da5ed82.svg";